import 'intl';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/es';
import './date-format-polyfill';
import { en, es, fr, registerTranslation } from 'react-native-paper-dates';
registerTranslation('en', en);
registerTranslation('es', es);
registerTranslation('fr', fr);
